export default "/images/vendor/flag-icon-css/flags/4x3/ms.svg?0c0db89dc3b203a23f739f4f99704f4d";